import React from 'react';
import { Menu, X, Crown } from 'lucide-react';

interface HeaderProps {
  onOpenModal: (modalType: 'privacy' | 'terms' | 'contact') => void;
}

export default function Header({ onOpenModal }: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  return (
    <header className="relative bg-gradient-to-r from-blue-900 via-indigo-900 to-blue-900 text-white">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1606402179428-a57976d71fa4?auto=format&fit=crop&q=80&w=1200')] opacity-10 bg-cover bg-center"></div>
      
      <nav className="relative container mx-auto px-4 py-6">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <Crown className="h-8 w-8 text-yellow-400" />
            <h1 className="text-2xl font-bold">GumTreeEscapesAU</h1>
          </div>
          
          <button 
            className="md:hidden"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          <div className="hidden md:flex space-x-8">
            <a href="#" className="hover:text-blue-200 transition-colors">Home</a>
            <button onClick={() => onOpenModal('privacy')} className="hover:text-blue-200 transition-colors">
              Privacy Policy
            </button>
            <button onClick={() => onOpenModal('terms')} className="hover:text-blue-200 transition-colors">
              Terms & Conditions
            </button>
            <button onClick={() => onOpenModal('contact')} className="hover:text-blue-200 transition-colors">
              Contact
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden mt-4 space-y-4">
            <a href="#" className="block hover:text-blue-200 transition-colors">Home</a>
            <button 
              onClick={() => onOpenModal('privacy')}
              className="block w-full text-left hover:text-blue-200 transition-colors"
            >
              Privacy Policy
            </button>
            <button 
              onClick={() => onOpenModal('terms')}
              className="block w-full text-left hover:text-blue-200 transition-colors"
            >
              Terms & Conditions
            </button>
            <button 
              onClick={() => onOpenModal('contact')}
              className="block w-full text-left hover:text-blue-200 transition-colors"
            >
              Contact
            </button>
          </div>
        )}
      </nav>
      
      <div className="relative container mx-auto px-4 py-24 text-center">
        <h2 className="text-5xl md:text-7xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-white via-blue-100 to-white">
          Welcome to the Ultimate Casino Experience
        </h2>
        <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto">
          Discover Poland's Most Luxurious Gaming Destinations
        </p>
        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-b from-transparent to-blue-50"></div>
      </div>
    </header>
  );
}